import React, { Component } from "react";
import { Modal, Carousel } from "react-bootstrap";
import "./ImageGalleryModal.css";

class ImageGalleryModal extends Component {
  render() {
    const { show, onHide, images, title, subtitle } = this.props;

    if (!images || images.length === 0) {
      return null;
    }

    // Default title and subtitle if not provided
    const modalTitle = title || "Vehicle Photos";
    const modalSubtitle = subtitle || null;

    return (
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        className="image-gallery-modal"
      >
        <Modal.Header closeButton>
          <div className="modal-title-container">
            <Modal.Title>
              {modalTitle} ({images.length})
            </Modal.Title>
            {modalSubtitle && (
              <div className="modal-subtitle text-muted">
                {modalSubtitle}
              </div>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Carousel interval={null} indicators={images.length > 1}>
            {images.map((image, index) => (
              <Carousel.Item key={index}>
                <div className="carousel-image-container">
                  <img
                    className="d-block w-100"
                    src={image.url || image.photo_url}
                    alt={`Vehicle ${index + 1}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect fill='%23ddd' width='400' height='300'/%3E%3Ctext fill='%23999' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3EImage not available%3C/text%3E%3C/svg%3E";
                    }}
                  />
                </div>
                {image.caption && (
                  <Carousel.Caption>
                    <p>{image.caption}</p>
                  </Carousel.Caption>
                )}
              </Carousel.Item>
            ))}
          </Carousel>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ImageGalleryModal;
